<template>
  <b-container class="society-list">
    <b-btn class="float-right" variant="primary" @click="createSociety">
      Create Society
    </b-btn>

    <h2>Societies</h2>

    <DataTable
      ref="dataTable"
      :show-filters="true"
      :show-pager="true"
      :get-items="getSocieties"
      :filters="filters"
      :filter-title="'Filter Societies'"
      :fields="fields"
    >
      <!-- template for filters -->
      <template slot="filters">
        <b-row>
          <b-col>
            <b-form-input v-model="filters.name.value" placeholder="Name" />
          </b-col>
          <b-col>
            <b-form-input
              v-model="filters.url_code.value"
              placeholder="URL Code"
            />
          </b-col>
        </b-row>
      </template>

      <!-- templates for custom columns -->
      <template slot="actions" slot-scope="data">
        <!-- we use @click.stop here to prevent emitting of a 'row-clicked' event  -->
        <b-dropdown
          split
          variant="info"
          size="sm"
          text="Edit"
          right
          @click.stop="editSociety(data.item.id)"
        >
          <b-dropdown-item-button @click.stop="editSocietyMapping(data.item.id)">
            Edit Mapping
          </b-dropdown-item-button>
          <b-dropdown-item-button @click.stop="editCertifyingBoards(data.item.id)">
            Edit Certifying Boards
          </b-dropdown-item-button>
          <b-dropdown-item-button @click.stop="onDelete(data.item.id)">
            Delete
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
    </DataTable>
  </b-container>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import Vue from 'vue';
import DataTable from '@/components/DataTable.vue';
import Api from '@/providers/Api.js';
import Help from '@/providers/Help';

export default Vue.extend({
  name: 'societyList',
  components: {
    DataTable,
  },
  data: function() {
    return {
      filters: {
        id: { field: 'id', value: null },
        name: { field: 'name', type: 'string', value: null },
        url_code: { field: 'url_code', type: 'string', value: null },
      },
      fields: [
        { key: 'id', sortable: true },
        { key: 'name', sortable: true },
        { key: 'url_code', sortable: true },
        { key: 'questionsCount', sortable: false, label: 'Questions' },
        {
          key: 'questionnairesCount',
          sortable: false,
          label: 'Questionnaires',
        },
        { key: 'usersCount', sortable: false, label: 'Users' },
        { key: 'specialtiesCount', sortable: false, label: 'Specialties' },
        { key: 'memberEmailsCount', sortable: false, label: 'Emails' },
        { key: 'actions', sortable: false, custom: true },
      ],
    };
  },
  methods: {
    createSociety: function() {
      this.$router.push(`/admin/society/create`);
    },
    editSociety: function(id) {
      this.$router.push(`/admin/society/edit/${id}`);
    },
    editSocietyMapping: function(id) {
      this.$router.push(`/admin/society/mapping/${id}`);
    },
    editCertifyingBoards: function(id) {
      this.$router.push(`/admin/society/certifying-boards/${id}`);
    },
    onDelete: function(id) {
      Help.confirm.show('Permanently delete this Society?', 'Delete', () => {
        this.deleteSociety(id);
      });
    },
    deleteSociety: function(id) {
      Api.deleteSociety(id).then(() => {
        this.$toasted.show('Society deleted', { duration: 3000 });
        this.$refs.dataTable.refresh();
      });
    },
    getSocieties: function(listParams) {
      return Api.getSocieties(this, this.filters, listParams);
    },
  },
});
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss"></style>
